import Alert from "@mui/material/Alert";
import type { ReactNode } from "react";

export function FormMessage({
  tone,
  children,
}: {
  tone: "success" | "error";
  children: ReactNode;
}) {
  return (
    <Alert
      role={tone === "error" ? "alert" : "status"}
      severity={tone === "error" ? "error" : "success"}
    >
      {children}
    </Alert>
  );
}
